mutation ApprovalDelete($input: ApprovalDeleteInput!) {
  approvalDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
